import React, { ReactNode } from 'react';
import { useField } from 'formik';
import { FormGroup, Label, Input, InputProps } from 'reactstrap';

interface IFormikRadioInputProps extends InputProps {
  children: ReactNode;
  disabled?: boolean;
  small?: boolean;
  formBox?: boolean;
  name: string;
}

const FormikRadioInput: React.FC<IFormikRadioInputProps> = ({
  children,
  disabled = false,
  small = false,
  formBox = true,
  name,
  ...props
}) => {
  // Using Formik's useField with type 'radio' to manage form state
  const [field] = useField({ name, value: props.value, type: 'radio' });

  const classNameArray = [`text-start ${formBox ? 'form-box' : 'mt-l custom-radio'}`];
  if (disabled) {
    classNameArray.push('disabled');
  }
  if (small) {
    classNameArray.push('small');
  }

  return (
    <FormGroup check className={classNameArray.join(' ')}>
      <Label check>
        <Input type="radio" {...field} {...props} disabled={disabled} />
        <span>{children}</span>
      </Label>
    </FormGroup>
  );
};

export default FormikRadioInput;
